module.exports = __webpack_public_path__ + "static/media/14_everstone.eb608901.svg";